import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicRegisters = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Registers and Register Files"
      videos={[
        "https://www.youtube.com/embed/Vt3lFnBwgpo",
      ]}
      takeaways={[
        { text: "Two types of registers: User-visible registers and Control & Status registers." }, 
        { text: "Direct question is possible, like explaining registers and register files." },
      ]}
      questions={[]} // Add questions if needed
      exampleVideos={[]} // Add example question videos if needed
    />
);
}

export default ModuleSubtopicRegisters;
